export default __webpack_public_path__ + "static/media/unlike_icon.05232f3b.png";